export enum HedgeAccountingStage {
  PendingJournalEntries = 'Pending Journal Entries',
  PendingAmortisation = 'Pending Amortisation',
  PendingNoHedgeCheck = 'Pending No-Hedge Check',
  DataReady = 'Data Ready',
}
